import { TableCell, TableHead, TableRow } from '@mui/material';

const COLUMNS = ['IN SCOPE', 'CATEGORY', 'DESCRIPTION', 'QTY', 'UNIT COST', 'MONTHLY COST'];
const RIGHT_ALIGNED = new Set(['QTY', 'UNIT COST', 'MONTHLY COST']);

/** The line-item table's column headings. */
export const InvoiceLinesHeader = ({ withRemove = false }: { withRemove?: boolean }) => (
  <TableHead className="bg-grey-1">
    <TableRow>
      {COLUMNS.map((column) => (
        <TableCell
          key={column}
          align={RIGHT_ALIGNED.has(column) ? 'right' : 'left'}
          className="text-xs font-medium text-grey-6">
          {column}
        </TableCell>
      ))}
      {withRemove && <TableCell />}
    </TableRow>
  </TableHead>
);
